
<div class="find-inventory-container flex flex-col justify-center px-10">
  <span class="find-inventory-text">FIND AN INVENTORY NEAR YOU</span>
  <div class="bg-img-container flex flex-col justify-end items-center">
    
    <div class="mb-4">
      <div class="flex flex-row justify-between items-center gap-1 shadow-2xl">
        <div class="input-container flex flex-row justify-around items-center">
          <div class="flex flex-row justify-between items-center gap-1 geolocate-container">
            <geolocate @success="searchByCoordinates" :showIcon="false" :onlyIcon="true" :iconHeight="'h-5'" />
            <div><span class="input-location-text">Use current location</span></div>
            <div><img v-if="loading" class="animate-spin h-4" src="@/images/spinner.svg" alt="Loading"></div>
          </div>
          <input
            @keyup.enter="search"
            v-model="query"
            @click="coordinates = null"
            :class="{ 'is-danger': error }"
            class="find-inventory-input bg-transparent w-full focus:ring-0 focus:outline-none"
            type="search"
            placeholder="Where are you located?"
          />
          <img @click="search" class="w-4" src="@/images/header/search-II.png" alt="search" />
        </div>
      </div>
      <div class="search-results-container">
        <div v-if="error" class="help py-1 text-center bg-white text-red-500 border rounded-md">
          {{ error }}
          <b><a @click.prevent="resetSearch()">Try Again</a></b>
        </div>
        <div v-if="cities.length" role="menu" class="mt-1 border rounded-md">
          <div class="dropdown-content modal-card-body" style="max-height: 300px !important;">
            <p class="dropdown-item"><b>We found mulitple results...</b></p>
            <a v-for="city in cities" :key="city.id" :href="cityPath(city.node)" class="dropdown-item">
              {{ city.node.name }}, {{ city.node.stateId | upcase }}
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
